import { textUtils } from './textUtils'

export const troubleCallType = "TC";
export const gfUndergroundInstallType = ["IN-87", "IN-89"]
export const rescueTroubleCallTypes = ["TC-12"];
export const skinnyInstallTypes = ["IN-21", "RC-44"];
export const serviceRequestType = "SR";
export const disconnectType = "DI";
export const SPPServiceCodes = ['3055', '3056', '3057', '3058', '3059', '3060'];

export const isSkinnyInstallType = (serviceTypeId) => {
  return skinnyInstallTypes.includes(serviceTypeId);
};

export const isGFUndergroundInstallType = (serviceTypeId) => {
  return gfUndergroundInstallType.includes(serviceTypeId);
}

export const isRescueTroubleCallType = (serviceTypeId) => {
  return rescueTroubleCallTypes.includes(serviceTypeId.toUpperCase());
}

export const isServiceRequestType = (serviceTypeId) => {
  return serviceTypeId.toUpperCase().startsWith(serviceRequestType);
}

export const isDisconnectType = (serviceTypeId) => {
  return serviceTypeId.toUpperCase().startsWith(disconnectType);
}

export const isTroubleCallType = (serviceTypeId) => {
  return serviceTypeId.toUpperCase().startsWith(troubleCallType) && !isRescueTroubleCallType(serviceTypeId.toUpperCase());
};

export const hasDetailsService = (chargeOptions, service) => {
  return chargeOptions.get('details').some(item => item.get('chargeGroup') === service);
};

export const getFirstServiceCallId = (chargeOptions) => {
  const options = chargeOptions.get('details').filter(item => item.get('chargeGroup') === 'serviceCallFee');
  if (options.size > 0) {
    return options.first().get('chargeID');
  }
};

export const getLastServiceCallId = (chargeOptions) => {
  const options = chargeOptions.get('details').filter(item => item.get('chargeGroup') === 'serviceCallFee');
  if (options.size > 0) {
    return options.last().get('chargeID');
  }
};

export const getAllServiceCallFeeOptions = (chargeOptions) => {
  const options = chargeOptions.get('details').filter(item => item.get('chargeGroup') === 'serviceCallFee');
  return options;
};

export const equipmentHitInterval = 120;

export const filterByModel = [
  'NONADDR',
  'EERO BASE',
  'WIFI ONLY'
];

export const hitActionRegistered = (hitRegister, outlet) => {
  const registeredEquipment = hitRegister ? hitRegister.find(equip => equip.serialNumber === outlet.get('seriaNumber')) : null;
  if (registeredEquipment) {
    return timeDifferenceInSeconds(registeredEquipment.date, new Date()) < equipmentHitInterval;
  }
  return false;
};

export const equipmentHitAllMessageBuilder = (serialNumbers) => {
  const serialNumberString = serialNumbers.reduce((acc, serialNumber) => acc + ", " + serialNumber);
  return textUtils.equipment.hit.hitAllFailed1 + serialNumberString + textUtils.equipment.hit.hitAllFailed2;
}

export const timeDifferenceInSeconds = (date, newDate) => {
  return Math.abs((newDate.getTime() - date.getTime()) / 1000);
};

export const isAlphaNumerical = (str) => {
  return str.search(/^[a-zA-Z0-9]+$/) !== -1;
}



// WEBPACK FOOTER //
// ./src/utils/helper.js